/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-09-01 10:39:32
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-01-10 11:48:21
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\SystemSettings\api\index.js
 */
import req from '@/utils/req.js'

export function getVideoList(params) {
    return req.post("/admin/video/page", params);
}
export function uploadImgs(data) {
    return req.post(`/dsicm-contact-platform/feign/file/upload`, data)
}
export function addVideo(params) {
    return req.post("/admin/video/insertReturnId", params);
}
export function getVideoTypeList(params) {
    return req.post("/admin/video-type/list", params);
}
export function VideoTypeAdd(params) {
    return req.post("/admin/video-type/insertReturnId", params);
}
export function VideoTypeupdate(params) {
    return req.put("/admin/video-type", params);
}
export function VideoTypeDelete(params) {
    return req.delete(`/admin/video-type/${params}`);
}
export function findDiseaseTypeByCondition(params) {
    return req.get("/admin/disease-type/findDiseaseTypeByCondition?conditionName=" + params);
}
export function getLabelDatabaseByName(params) {
    return req.post("/admin/label-database/getLabelDatabaseByName", params);
}
export function getLabelDatabaseByNameNew(params) {
    return req.post("/admin/label-database/getLabelDatabaseNameByName", params);
}
export function getVideoDetail(params) {
    return req.get("/admin/video/" + params);
}
export function updateStatus(params) {
    return req.put("/admin/video/updateStatus?id=" + params);
}
export function updateVideo(params) {
    return req.put("/admin/video", params);
}
export function deleteVideo(params) {
    return req.delete("/admin/video/" + params);
}
export function getInformationPage(params) {
    return req.post("/admin/information/page", params);
}

// 置顶/取消置顶
export function getInformationSetTop(id) {
    return req.put(`/admin/information/setTop/${id}`);
}
export function updateInformationStatus(params) {
    return req.put("/admin/information/updateStatus/" + params);
}
export function getInformationDetail(params) {
    return req.get("/admin/information/" + params);
}
export function deleteInformation(params) {
    return req.delete("/admin/information/" + params);
}
export function informationAdd(params) {
    return req.post("/admin/information", params);
}
export function getInformationVideoPage(params) {
    return req.post("/admin/video/getVideoPage", params);
}
export function getVideoCollection() {
    return req.get("/admin/video/getVideoCollection");
}
export function quoteVideo(id) {
    return req.get(`/admin/video/quote/${id}`);
}
export function OrQuoteVideo(id) {
    return req.get(`/admin/information/quote/${id}`);
}

export function findConceptByTitle() {
    return req.get('https://sit-rws.dsicm.com/api/api/cohort/findAllCondition?cohortId=1519582920928075777&type=in')
}


//配置权重
export function sortWeight(params) {
    return req.put("/admin/information/sort-weight", params);
}